import React from 'react';
import classNames from 'classnames';

import '@styles/loader.scss';

interface LoaderProps {
  className?: String;
}

const Loader = ({ className }: LoaderProps) => {
  return (
    <div
      className={classNames('loader', className)}
      data-cy="loader"
      data-testid="loader"
      role="status"
    >
      <div className="loader__spinner"></div>
      <div className="loader__image"></div>
    </div>
  );
};

export default Loader;
